export { default as ProductBadge } from './ProductBadge';
